/**
 * @module app.cm
 */

import { autoinject } from 'aurelia-framework';
import { ComponentBase } from 'app/shared/lib/essette-site';
import { CasePageContext } from 'app/cm/lib/case-page-context';

@autoinject()
export class CarePlanPage extends ComponentBase {

    ////****************** Fields and Properties ************************************////
    protected caseId!: string;
    protected readonly: boolean = false;

    ////****************** Element References ***************************************////


    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(
        private readonly context: CasePageContext,
        ...rest: any[]) {

        super(...rest);
    }

    protected async canActivate(params: { caseId: string }): Promise<boolean> {
        if(!params.caseId) { throw new Error('Missing or invalid caseId parameter'); }

        return true;
    }

    protected async activate(params: { caseId: string }): Promise<void> {
        if(this.caseId !== params.caseId) { this.caseId = params.caseId; }

        await this.accountContext.load();
        const canEditClosedCase = this.accountContext.hasPermission('CM.Case.Duty.EditClosedCase');

        if(this.context && this.context.case) {
            this.readonly = this.context.caseIsReadOnly(canEditClosedCase);
        }
    }

    ////****************** Events ***************************************************////


    ////****************** Functions ************************************************////


    ////****************** Service Calls ********************************************////

}
